import React from 'react';
import { FacilityImageAndDetails } from 'components/facility/FacilityImageAndDetails';
import { PhoneNumber } from 'components/contact/PhoneNumber';
import { Text } from 'components/core/Text';
import { UnitPrice } from 'components/unit/UnitPrice';
import { Link } from 'components/core/Link';
import { Button } from 'components/core/Button';
import { ViewportAction } from 'components/core/ViewportAction';
import { withOnVisibleFacilityHandler } from 'decorators/facility';

import PropTypes from 'prop-types';

import './FacilityGridCard.scss';

export const enhance = withOnVisibleFacilityHandler;

export function FacilityGridCard({
	facility,
	withPhone,
	withUnitsAndPrice,
	withButtonLink,
	onVisible,
	percentVisible
}) {
	return (
		<ViewportAction
			onVisible={onVisible}
			percentVisible={percentVisible}
			className="facility-grid-item"
			key={facility.id}
		>
			<div className="facility-grid-card">
				<FacilityImageAndDetails
					withReviews
					reviewData={facility.reviewMetadata}
					distance={facility.distance}
					facilityUrl={facility.url.facility}
					image={facility.images && facility.images[0]}
					name={facility.name}
					location={facility.location}
				/>
				<div className="facility-grid-card-details">
					{!!withPhone && facility.phone &&
						<PhoneNumber
							className="facility-card-phone"
							phoneNumber={facility.phone}
							clickable
						/>
					}
					{!!withUnitsAndPrice && facility.cheapestPrice &&
						<div className="facility-card-unit">
							<Text
								strong
								size="small"
								className="facility-card-unit-text"
							>
								{facility.unitCount} units starting at
							</Text>
							<UnitPrice
								className="facility-card-unit-price"
								price={facility.cheapestPrice.text}
							/>
						</div>
					}
					{!withButtonLink &&
						<div className="facility-card-link">
							<Link
								href={facility.url.facility}
							>
								View all units &raquo;
							</Link>
						</div>
					}
					{!!withButtonLink &&
						<Button
							fullWidth
							href={facility.url.facility}
						>
							View facility
						</Button>
					}
				</div>
			</div>
		</ViewportAction>
	);
}

FacilityGridCard.propTypes = {
	facility: PropTypes.object,
	withPhone: PropTypes.bool,
	withUnitsAndPrice: PropTypes.bool,
	withButtonLink: PropTypes.bool,
	onVisible: PropTypes.func,
	percentVisible: PropTypes.number
};

export default enhance(FacilityGridCard);
